import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  data() {
    return {
      dataFrom: {},
      dialogVisible: false
    };
  },
  computed: {
    statusName() {
      return this.$t(this.dataFrom.statusName);
    },
    payType() {
      return this.$t(this.dataFrom.payType);
    },
    operationName() {
      var _this$dataFrom$operat;
      // console.log(this.dataFrom.operationName);
      if ((_this$dataFrom$operat = this.dataFrom.operationName) !== null && _this$dataFrom$operat !== void 0 && _this$dataFrom$operat.length) {
        return this.$t(this.dataFrom.operationName);
      } else {
        return '';
      }
    }
  },
  methods: {
    init(record) {
      this.dataFrom = recursionCopy(record);
      this.dialogVisible = true;
    }
  }
};